export default "__VITE_ASSET__BT0V1B38__"